/**
* @desc translate strings synchronously using `$translate.instant`
* @example <twp-translate>TRANSLATION_ID</twp-translate>
*/

function twpTranslateDirective($translate) {
  return {
    restrict: 'EA',
    replace: true,
    scope: true,
    link(scope, el) {
      const [element] = [...el];
      if (element) {
        const translationId = element.innerText.toUpperCase();

        element.innerText = $translate.instant(translationId);
      }
    }
  };
}

const arr = [
  '$translate',
  twpTranslateDirective
];

module.exports = (ngModule) => {
  ngModule.directive('twpTranslate', arr);
};
